export default "__VITE_ASSET__B2ggurJ8__"